import React from 'react';
import UserCoinResponse from '@src/responsive/UserCoinResponse';
import _ from 'lodash';
import cn from 'clsx';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useTheLayouotCtrl } from '@src/hooks';
import ModalContainer from '@src/lib/CustomModal/ModalContainer';

const WithHistory = dynamic<any>(
  () => import('@src/middleware/history').then((mod: any) => mod.WithHistory),
  {
    ssr: false,
  },
);

const ApiResponse = dynamic<any>(() => import('@src/responsive/ApiResponse'), {
  ssr: false,
});

const GlobalEventResponse = dynamic<any>(
  () => import('@src/responsive/globalProcess/GlobalEventResponse'),
  { ssr: false },
);

const NsfwBtn = dynamic<any>(() => import('@src/view/common/nsfwBtn/NsfwBtn'), {
  ssr: false,
});

const PersistResponse = dynamic<any>(
  () => import('@src/responsive/PersistResponse'),
  { ssr: false },
);

const Header = dynamic<any>(
  () => import('@src/view/theLayout/Header').then((mod: any) => mod.Header),
  { ssr: false },
);

const Footer = dynamic<any>(
  () => import('@src/view/theLayout/Footer').then((mod: any) => mod.Footer),
  { ssr: false },
);

const AcceptCookieComponent = dynamic<any>(
  () =>
    import('@src/view/components/acceptCookies').then(
      (mod: any) => mod.AcceptCookieComponent,
    ),
  { ssr: false },
);

const GlobalModalController = dynamic<any>(
  () => import('@src/middleware/GlobalModalController'),
  { ssr: false },
);

interface PropTypes {
  children: React.ReactNode;
}
const TheLayout = (props: PropTypes) => {
  const { children } = props;
  const router = useRouter();
  const { layoutHidden, isLoading } = useTheLayouotCtrl();
  const { headerHidden, footerHidden, bodyWrapperHidden } = layoutHidden;

  return (
    <div
      className={'h-inherit min-h-inherit'}
      // 드래그시 url 노출 방지
      onDragStart={e => e.preventDefault()}
    >
      <ModalContainer />
      <ApiResponse />
      <GlobalEventResponse />
      <WithHistory />
      {/* 모든페이지에 노출되는 모달 순서 controller */}
      <GlobalModalController />
      <PersistResponse />
      <UserCoinResponse />
      <AcceptCookieComponent />
      <Header hidden={headerHidden} />
      <div
        id="bodyWrapperCon"
        className={cn(
          `max-w-[1200px] w-full py-[30px] mx-auto px-[10px] h-auto min-h-[70vh] mo:min-h-[65vh]`,
          'tablet:my-0 tablet:py-0',
          // 회차리스트 페이지 헤더 비노출 조건에 맞춰 CSS 수정 함
          {
            ['max-w-none w-full mx-auto !py-[0px] !px-0']:
              router.pathname === '/payment' ||
              router.pathname === '/payment/list' ||
              router.pathname.includes('/nsfw'),
            ['tablet:px-0']: headerHidden,
            ['middle:px-[15px] mo:px-[10px]']:
              bodyWrapperHidden && headerHidden,
            ['max-w-full !mt-0  !py-0 !px-0 middle:px-0 mo:!px-0 min-h-0 mo:min-h-0']:
              bodyWrapperHidden,
          },
        )}
      >
        {children}

        <NsfwBtn />
      </div>
      <Footer hidden={footerHidden} />
    </div>
  );
};
export default TheLayout;
